import React, { useContext, useEffect, useState } from 'react'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Button from '../../ui-library/components/Button'
import {
  getAdminUsers,
  resetAppUser,
} from '../../handlers/requests/users/appUsersHandler'


import {
  getProducts
} from '../../handlers/requests/sheffmed/orders.js'

import {
  getOrders,
  uploadInvoiceNumbers
} from '../../handlers/requests/sheffmed/orders.js'

import { OrganisationContext } from '../../context/OrganisationContext'
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '../../ui-library/components/DataTable'
import { ThemeContext } from '../../ui-library/components/ThemeContext'
import LoadingAnim from '../../ui-library/components/loadingAnim/LoadingAnim'
import useDebounce from '../../hooks/useDebounce'
import moment from 'moment'
import uuid from 'react-uuid'
import Typography from '../../ui-library/components/Typography'
import IconButton from '../../ui-library/components/IconButton'
import { FaDatabase, FaDownload, FaEdit, FaEye, FaLink, FaUpload, FaUser, FaUserPlus } from 'react-icons/fa'
import DashboardContainer from '../../ui-library/components/DashboardContainer'
import TabHeader from '../../ui-library/components/TabHeader'
import { useNavigate } from 'react-router-dom'
import { AlertContext } from '../../context/AlertContext'
import ConfirmationModal from '../../ui-library/components/dialogs/ConfirmationModal'
import { Tab } from '@mui/material'

function Orders(props) {
  const [loading, setLoading] = useState(false)
  // const [search, setSearch] = useState('')
  const { currentOrg } = useContext(OrganisationContext)
  const { theme } = useContext(ThemeContext)
  const { setAlert } = useContext(AlertContext)

  // const debouncedSearch = useDebounce(search, 1000)
  const navigate = useNavigate()
  // const [confirmReset, setConfirmReset] = useState(false)
  // const [selectedUser, setSelectedUser] = useState(false)

  const [uploadProcessing, setUploadProcessing] = useState(false)

  const [orderData, setOrderData] = useState([])

  useEffect(() => {
    let doRequest = async () => {
      setLoading(true)

      const orders = await getOrders()
      if (orders?.data) {

        // sort by createdAt DESC
        orders.data.sort((a, b) => {
          return new Date(b.createdAt) - new Date(a.createdAt)
        })
        
        setOrderData(orders.data)
      }

      setLoading(false)
      console.log("orders", orders)
      // if (debouncedSearch) {
      //   const users = await getAdminUsers(search)
      //   setUserData(users?.data)
      //   setLoading(false)
      // } else {
      //   const users = await getAdminUsers('')
      //   setUserData(users?.data)
      //   setLoading(false)
      // }
    }
    doRequest()
  }, [currentOrg])

  const startUpload = async () => {



    // show file picker
    const file = await window.showOpenFilePicker({
      types: [
        {
          description: 'Excel Files',
          accept: {
            'application/vnd.ms-excel': ['.xlsx'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
          },
        },
      ],
    })

    setUploadProcessing(true)

    const fileHandle = await file[0].getFile()
    const fileName = fileHandle.name
    const fileType = fileHandle.type
    const fileSize = fileHandle.size
    
    console.log('fileHandle', fileHandle)
    // Use the file directly - don't convert to text first as Excel files are binary


    // set 

    let response = await uploadInvoiceNumbers(fileHandle, fileName)


    if (response?.error) {
      alert(`Error uploading file ${fileName} - please try again`)
    } else {
      alert(`File ${fileName} uploaded successfully - please wait while we process the file`)
      window.location.reload() // reload the page to get the new data
    }
    // alert(`File ${fileName} uploaded successfully - please wait while we process the file`)

    setUploadProcessing(false)

  }

  return (
    <DashboardContainer>
      <TabHeader
        title={'Orders'}
        // showSearch
        // searchValue={search}
        // onChangeSearch={(e) => setSearch(e.target.value)}
      >
        <Paper
          style={{
            ...theme?.dashboard?.container,
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
          <Button
              source={'altButton'}
              icon={FaUpload}
              icontype={'endIcon'}
              onClick={() => {
                startUpload()
              }}
              style={{ width: 330 }}
              width={330}
            >
              {!uploadProcessing ? "Upload Invoice Template" : "Processing..."}
            </Button>
            {/*<Button
              source={'altButton'}
              icon={FaDownload}
              icontype={'endIcon'}
              onClick={() => {
                window.alert('Temporarily disabled')
                // navigate('/dashboard/orders/add', {
                //   state: { title: 'Add System User' },
                // })
              }}
            >
             Download
            </Button>*/}

    
          </div> 
          <>
            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              {loading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '70vh',
                  }}
                >
                  <LoadingAnim />
                </div>
              ) : orderData?.length > 0 ? (
                <TableContainer {...props} theme={theme}>
                  <Table {...props} theme={theme}>
                    <TableHead {...props} theme={theme}>
                      {['Reference', 'User', 'Order Time', 
                        'Total','Action'
                    ]?.map(
                        (header, index) => {
                          return (
                            <TableCell {...props} key={index} theme={theme}>
                              <Typography
                                source={'h3'}
                                style={
                                  header === 'Action'
                                    ? {
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        marginRight: 20,
                                      }
                                    : {}
                                }
                              >
                                {header}
                              </Typography>
                            </TableCell>
                          )
                        }
                      )}
                    </TableHead>
                    {orderData?.map((order, index) => {
                      const title =
                        order?.reference !== null ? order?.reference : ''
                      // const lastname =
                      //   order?.lastname !== null ? order?.lastname : ''
                      const lastUpdated = moment(order?.createdAt).format('DD/MM/YYYY HH:mm')

                      console.log('order', order)

                      return (
                        <TableRow theme={theme} {...props} key={uuid()}>
                          <TableCell theme={theme} {...props} align="left">
                            <Typography source={'h3'}>{`${title}`}</Typography>
                          </TableCell>

                          <TableCell theme={theme} {...props}>
                            <Typography source={'h3'}>
                              {order?.user?.companyName}
                            </Typography>
                            <Typography>
                              {order?.user?.firstName} {order?.user?.lastName} - {order?.user?.email}
                            </Typography>
                          </TableCell>

                          <TableCell theme={theme} {...props}>
                            <Typography>{lastUpdated === 'Invalid date' ? 'N/A' : lastUpdated}</Typography>
                          </TableCell>

                          <TableCell theme={theme} {...props}>
                            <Typography>{order.totalPriceDisplay}</Typography>
                          </TableCell>
                          <TableCell theme={theme} {...props}>
                            {/* <IconButton
                              source={'tableIcon'}
                              style={{ float: 'right', color: 'red' }}
                              icon={FaLink}
                              onClick={() => {
                                setSelectedUser(order)
                                setConfirmReset(true)
                              }}
                            /> */}
                            <IconButton
                              source={'tableIcon'}
                              style={{ float: 'right' }}
                              icon={FaEye}
                              onClick={() => {
                                // navigate('/dashboard/domains/views')
                                navigate('/dashboard/orders/edit', {
                                  state: { order },
                                })
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </Table>
                </TableContainer>
              ) : (
                <Typography
                  source={'h1'}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '70vh',
                  }}
                >
                  No Data
                </Typography>
              )}
            </Stack>
            {/* <ConfirmationModal
              onAccept={async () => {
                await resetAppUser(selectedUser?.email, setAlert)
                setConfirmReset(false)
              }}
              isOpen={confirmReset}
              onRequestClose={() => setConfirmReset(false)}
              type={'Reset'}
              text={'Are you sure you wish to reset this users password?'}
              icon={FaUser}
            /> */}
          </>
        </Paper>
      </TabHeader>
    </DashboardContainer>
  )
}

export default Orders
